import React, { PropTypes } from 'react';

import { NitroAccordion } from 'nitro-components';

import FeatureList from './FeatureList';

const IncludedExtras = ({ options, active }) => {
  let extras = [];
  for (const option of options) {
    if (option.Standard) {
      extras.push(option.Description);
    }
  }

  if (!options) {
    return null;
  }

  return <NitroAccordion title="Included extras" details={<FeatureList list={extras} />} active={active} />;
};

IncludedExtras.propTypes = {
  options: PropTypes.array.isRequired,
  active: PropTypes.bool
};

export default IncludedExtras;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/components/accordions/IncludedExtras.js